import { render, staticRenderFns } from "./sidebar.btn.group.vue?vue&type=template&id=609051f3"
import script from "./sidebar.btn.group.vue?vue&type=script&lang=js"
export * from "./sidebar.btn.group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports